var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"XKetcher__warp"},[_c('iframe',{ref:"ketcherFrame",attrs:{"src":"/static/ketcher/index.html"}})])}
var staticRenderFns = []

export { render, staticRenderFns }